import React, { useEffect, useContext, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import "./NotesList.css";
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";
import {
  getPatientNotesById,
  CreateNote,
  updateNote,
  deletePatient,
} from "../services/patientService";
import { toast } from "react-toastify";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import Modal from "react-bootstrap/Modal";
import reddelete from "../../images/red-Delete.svg";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import editicon from "../../images/edit-icon.svg";
import binicon from "../../images/bin-icon.svg";
import { useFormik } from "formik";
import { formikNotes } from "./validation";
import { SocketContext } from "../../socket/SocketContext";
import eyeimg from "../../images/eye.svg";
import Loader from "../../utils/Loader";


export default function NotesList({ patient }) {
  const { data } = useSelector((state) => state.login);
  const [patientMedicationPlan, setPatientMedicationPlan] = useState([]);
  const [selectedSortValue, setSelectedSortValue] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedValue, setSelectedValue] = useState("");
  const [editData, setEditData] = useState(null);
  const [modalShow, setModalShow] = React.useState(false);
  const [deleteModelShow, setDeleteModelShow] = React.useState(false);
  const [modalViewShow, setModalViewShow] = React.useState(false);
  const socket = useContext(SocketContext);
  const [loading, setLoading] = useState(false);

  const handleEdit = (data) => {
    setModalShow(true);
    setEditData(data);
    formik.setValues({
      _id: data._id || "",
      title: data.title || "",
      content: data.content || "",
    });
  };

  const handelDeleteModel = (data) => {
    formik.setValues({
      title: data.title,
      content: data.content,
      _id: data._id,
    });
    setDeleteModelShow(true);
  };

  /* Function's */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchPatientNotesById(selectedValue);
  }, [page, limit]);

  const formik = useFormik({
    ...formikNotes,
    onSubmit: async (values) => {
      values.patientID = patient;
      values.providerID = data._id;

      try {
        let res;
        if (values._id) {
          res = await updateNote(values);
        } else {
          res = await CreateNote(values);
          values.senderType = "User";
          socket?.emit("create-notification", values);
        }

        formik.setValues({
          title: "",
          content: "",
        });

        if (res.status === "SUCCESS") {
          fetchPatientNotesById(selectedValue);

          toast.success(res.data.message);
          setModalShow(false);
        } else {
          toast.error(res.data.message);
          setModalShow(false);
        }
      } catch (error) {
        toast.error("Failed!");
        setModalShow(false);
      }
    },
  });

  const ViewNote = (note) => {
    formik.setValues({
      _id: note._id || "",
      title: note.title || "",
      content: note.content || "",
    });
    setModalViewShow(true);
  };

  const fetchPatientNotesById = async (eventKey, searchText = "") => {
    try {
      setLoading(true)
      const response = await getPatientNotesById({
        patientID: patient,
        providerID: data._id,
        page: page + 1,
        limit,
        searchKey: searchText,
        sortBy: eventKey,
      });
      if (response?.status === "SUCCESS") {
        setPatientMedicationPlan(response?.data.list);
        setTotalPages(response?.data?.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
      setLoading(false)

    } catch (error) {
      setLoading(false)

      toast.error("Please try again later");
    }
  };

  const handleSelect = (eventKey) => {
    setSelectedValue(eventKey); // Update the state with the selected value
    fetchPatientNotesById(eventKey);
  };

  const deleteNote = async () => {
    await deletePatient(formik.values._id);
    fetchPatientNotesById(selectedSortValue);
    setDeleteModelShow(false);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchText(query);
    if (query.length >= 3 || query.length === 0) {
      fetchPatientNotesById(selectedSortValue, query);
    }
  };


  return (
    <>
      {
        loading && <Loader />
      }
      <div className="Dashboard-lft-blk">
        <div className="add-doctor">
          <Form>
            <Form.Group controlId="searchInput">
              <Form.Control
                type="search"
                aria-label="Search"
                value={searchText}
                onChange={handleSearchChange}
                placeholder="Search Notes By Content..."
              />
            </Form.Group>
          </Form>

          {/* <Link to="/admin/patient/add-note"> */}
          <Button
            className="filled-btn"
            onClick={() => {
              setModalShow(true);
              formik.setValues({
                title: "",
                content: "",
              });
            }}
          >
            Add Notes
          </Button>
          {/* </Link> */}

          <Dropdown className="patient-info-dropdown " onSelect={handleSelect}>
            <Dropdown.Toggle className="db-dropdown h-100">
              {selectedValue === ""
                ? "Sort By"
                : selectedValue === "recent"
                  ? "recent"
                  : "oldest"}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item eventKey="">Default</Dropdown.Item>

              <Dropdown.Item eventKey="recent">Recent</Dropdown.Item>
              <Dropdown.Item eventKey="oldest">Oldest</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* table for tratment lis  */}
        <div className="table-responsive dashboard-table">
          <table className="patients-table">
            <thead>
              <tr className="t-row-block">
                <th scope="col">Sr No</th>
                {/* Set fixed width for the Title column */}
                <th scope="col">Title</th>
                <th scope="col">Created At</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {patientMedicationPlan?.length > 0 ? (
                patientMedicationPlan?.map((note, index) => (
                  <tr key={note.id || index}>
                    <td scope="row" style={{ borderLeft: "0px" }}>
                      {++index}
                    </td>
                    <td>{note.title}</td>
                    <td style={{ borderRight: "0px" }}>
                      {new Date(note?.createdAt).toLocaleString("en-US", {
                        hour12: true,
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                      })}
                    </td>
                    <td>
                      <div className="d-flex gap-3">
                        <a
                          className="edit-del-icon eye-edit-del eye-img"
                          onClick={() => {
                            ViewNote(note);
                          }}
                        >
                          <img src={eyeimg} alt="view" />
                        </a>

                        <a
                          className="edit-del-icon eye-edit-del eye-img"
                          onClick={() => {
                            handleEdit(note);
                          }}
                        >
                          <img src={editicon} alt="edit" />
                        </a>
                        <a
                          className="edit-del-icon eye-edit-del eye-img"
                          onClick={() => handelDeleteModel(note)}
                        >
                          <img src={binicon} alt="delete" />
                        </a>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Notes Found for Patient
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="pagination-blk">
          <CustomPagination
            totalItems={totalItems}
            page={page}
            onPageChange={handleChangePage}
            limit={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>

      {/* add /edit note modal */}
      <Modal
        className="dlt-patient-modal add-edit-notes-modal"
        show={modalShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setModalShow(false)}
      >
        <Modal.Body>
          <Form className="" onSubmit={formik.handleSubmit}>
            <div className="">
              <div className="form-control-area">
                <Form.Group
                  className="mb-3 text-start"
                  controlId="exampleForm.ControlInputFirstName"
                >
                  <Form.Label className="details">
                    Title<span className="asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter title here..."
                    name="title"
                    keyField={"title"}
                    formik={formik}
                    value={formik.values.title}
                    onChange={(e) =>
                      formik.setFieldValue("title", e.target.value)
                    }
                    onBlur={formik.handleBlur}
                  />

                  {formik.touched.title && formik.errors.title ? (
                    <div className="text-danger mt-1">
                      {formik.errors.title}
                    </div>
                  ) : null}
                </Form.Group>
                <Form.Group
                  className="mb-4 text-start"
                  controlId="exampleForm.ControlInputFirstName"
                >
                  <Form.Label className="details">
                    Content<span className="asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    as="textarea"
                    rows={5} // Optional: Adjust the number of rows for the textarea
                    placeholder="Enter content here..."
                    name="content"
                    keyField={"content"}
                    formik={formik}
                    value={formik.values.content}
                    onChange={(e) =>
                      formik.setFieldValue("content", e.target.value)
                    }
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.content && formik.errors.content ? (
                    <div className="text-danger mt-1">
                      {formik.errors.content}
                    </div>
                  ) : null}
                </Form.Group>
              </div>
            </div>

            <div className="authentication-btns d-flex justify-content-center gap-4">
              <Button
                className="btn border-btn btn-no"
                onClick={() => setModalShow(false)}
              >
                Cancel
              </Button>
              {formik.values._id ? (
                <Button className="btn dark-btn btn-yes" type="submit">
                  Update
                </Button>
              ) : (
                <Button className="btn dark-btn btn-yes" type="submit">
                  Add
                </Button>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* view model  */}

      {/* add /edit note modal */}
      <Modal
        className="dlt-patient-modal add-edit-notes-modal "
        show={modalViewShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setModalViewShow(false)}
      >
        <Modal.Body>
          <div className="view-media-block">
            <div className="form-control-area">
              <Form.Group
                className="mb-3 text-start"
                controlId="exampleForm.ControlInputFirstName"
              >
                <Form.Label className="details">
                  Title<span className="asterisk">*</span>
                </Form.Label>

                <p className="text-dark"> {formik.values.title} </p>
              </Form.Group>
              <Form.Group
                className="mb-4 text-start"
                controlId="exampleForm.ControlInputFirstName"
              >
                <Form.Label className="details">
                  Content<span className="asterisk">*</span>
                </Form.Label>

                <p className="text-dark"> {formik.values.content} </p>
              </Form.Group>
            </div>
          </div>

          <div className="authentication-btns d-flex justify-content-center gap-4">
            <Button
              className="btn border-btn btn-no"
              onClick={() => setModalViewShow(false)}
            >
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* delete patient modal */}
      <Modal
        className="dlt-patient-modal"
        show={deleteModelShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDeleteModelShow(false)}
      >
        <Modal.Body>
          <div className="d-flex justify-content-center mb-3">
            <div className="delete-img">
              <img src={reddelete} alt="img"></img>
            </div>
          </div>
          <h4>Are you sure? </h4>
          <p>You want to detele this note</p>
          <div className="authentication-btns d-flex justify-content-center gap-4">
            <Button
              className="btn border-btn btn-no outlined-btn"
              onClick={() => setDeleteModelShow(false)}
            >
              No
            </Button>
            <Button
              className="btn dark-btn btn-yes"
              onClick={() => deleteNote()}
            >
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
